const solutionsSectionResources = {
    linkLearnMore: 'Learn more'
};
export default solutionsSectionResources;